<template>
  <expandable-material-card
    :title="$t('components.portal.theme_options')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="palette"
  >
    <v-card-actions>
      <v-spacer />
      <v-btn :disabled="allExpanded" text @click="all">
        {{ $t("globals.expand_all") }}
      </v-btn>
      <v-btn :disabled="allCollapsed" text @click="none">
        {{ $t("globals.collapse_all") }}
      </v-btn>
    </v-card-actions>
    <v-card-text>
      <v-expansion-panels v-model="panel" style="margin-top:10px" multiple v-if="portal!==null && portal!==undefined">
        <theme-colors
          :theme="portal.theme"
          @update="$emit('update-theme-colors',$event)"
          @valid="valid.themeColors = $event"
        />
        <left-drawer
          :theme="portal.theme"
          @update="$emit('update-left-drawer',$event)"
          @valid="valid.leftDrawer = $event"
        />
        <right-drawer
          :theme="portal.theme"
          @update="$emit('update-right-drawer',$event)"
          @valid="valid.rightDrawer = $event"
        />
        <app-bar
          :theme="portal.theme"
          @update="$emit('update-app-bar',$event)"
          @valid="valid.appBar = $event"
        />
        <app-footer
          :theme="portal.theme"
          @update="$emit('update-app-footer',$event)"
          @valid="valid.appFooter = $event"
        />
        <main-view
          :theme="portal.theme"
          @update="updateMainView"
          @valid="valid.mainView = $event"
        />
      </v-expansion-panels>
    </v-card-text>
  </expandable-material-card>
</template>

<script>
import { mapGetters } from "vuex";
import ExpandableMaterialCard from "./ExpandableMaterialCard.vue";
import ThemeColors from "@/components/Portal/Theme/ThemeColors.vue";
import LeftDrawer from "@/components/Portal/Theme/LeftDrawer.vue";
import RightDrawer from "@/components/Portal/Theme/RightDrawer.vue";
import AppBar from "@/components/Portal/Theme/AppBar.vue";
import AppFooter from "@/components/Portal/Theme/AppFooter.vue";
import MainView from "@/components/Portal/Theme/MainView.vue";

export default {
  components: {
    ThemeColors,
    LeftDrawer,
    RightDrawer,
    AppBar,
    AppFooter,
    MainView,
    ExpandableMaterialCard,
  },
  props: ["dataContainer"],
  data() {
    return {
      valid: {
        themeColors: false,
        leftDrawer: false,
        rightDrawer: false,
        appBar: false,
        appFooter: false,
        mainView: false,
      },
      portal: null,
      panel: [0, 1, 2, 3, 4, 5],
      items: 6,
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    ...mapGetters("plansMembers", ["options"]),
    allExpanded() {
      return (
        JSON.stringify(this.panel) ===
        JSON.stringify([...Array(this.items).keys()].map((k, i) => i))
      );
    },
    allCollapsed() {
      return JSON.stringify(this.panel) === JSON.stringify([]);
    },
  },
  watch: {
    dataContainer: {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.portal = JSON.parse(JSON.stringify(v.portal));
        }
      },
    },
    portal: {
      handler(v) {
        this.$emit("update", v.theme);
      },
      deep: true,
    },
    valid: {
      handler(v) {
        console.log("theme options valid: ", v);
        this.$emit("valid", this.isValidFunc());
      },
      deep: true,
    },
  },
  mounted() {
    if (this.dataContainer !== null && this.dataContainer !== undefined) {
      this.portal = JSON.parse(JSON.stringify(this.dataContainer.portal));
      this.all();
      this.$nextTick(() => {
        this.$emit("valid", this.isValidFunc());
      });
    }
  },
  methods: {
    updateMainView(e) {
      console.log("--------------updateMainView: ", e);
      this.$emit('update-main-view',e)
    },
    all() {
      this.panel = [...Array(this.items).keys()].map((k, i) => i);
    },
    none() {
      this.panel = [];
    },
    isValidFunc() {
      const keys = Object.keys(this.valid);
      for (let key of keys) {
        if (this.valid[key] === false) {
          console.log(
            "is valid theme:-----------------------------------------------------------------------------",
            key,
            this.valid
          );
          return false;
        }
      }
      return true;
    },
  },
};
</script>
